export const blogFiles = [
  { slug: "boilerclasses", filePath: "/blog/boilerclasses.md" },
  { slug: "stacks", filePath: "/blog/stacks.md" },
  { slug: "shamir", filePath: "/blog/shamir.md" },
];

export const selectedThings = [
  {
    label: "Tensara",
    href: "https://tensara.org/",
  },
  {
    label: "distributed systems research",
    href: "https://github.com/SohamJog/reliable-broadcast-protocols/",
  },
  {
    label: "BoilerClasses",
    href: "https://www.boilerclasses.com/",
  },
  {
    label: "GitHub",
    href: "https://github.com/sohamjog/",
  },
];

export const elsewhereLinks = [
  {
    label: "GitHub",
    href: "https://github.com/sohamjog/",
  },
  {
    label: "X",
    href: "https://twitter.com/jog_soham",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/soham-jog-ba4b62237/",
  },
  {
    label: "Email",
    href: "mailto:jogsoham2003@gmail.com",
  },
];
